module.exports = __webpack_public_path__ + "static/media/shuzhuangtu.e0690511.png";